<template>
    <div class="space-y-3">
        <section class="space-y-1">
            <form-label>Entity</form-label>
            <EntitySelector :model-value="node.data.entityId" :settings="settings" placeholder="light.kitchen"
                @update:model-value="entityId => hass.updateNodeData(page, node.id, { entityId: String(entityId ?? '').trim() })" />
        </section>
        <section class="space-y-1">
            <form-label>Feeds and targeted by</form-label>
            <p v-if="!feeds.length" class="text-xs text-gray-300">
                Drag a wire from this entity to a binding or to an object (its Primary Entity), or from an action's target output to this entity.
            </p>
            <div v-for="item in feeds" :key="item.wire.id"
                class="flex items-center gap-1 rounded border border-white/20 bg-white/5 px-1 py-0.5 text-xs">
                <button v-if="item.nodeId" class="min-w-0 flex-1 truncate text-left hover:text-ui-active"
                    @click="hass.select(page, 'node', item.nodeId)">{{ item.label }}</button>
                <span v-else class="min-w-0 flex-1 truncate">{{ item.label }}</span>
                <button class="text-red-300 hover:text-red-200" title="Disconnect" @click="hass.removeWire(page, item.wire.id)">×</button>
            </div>
        </section>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useHassFlowStore } from '../../stores/hassFlowStore.js';
import { findNode } from '../../graph/graphModel.js';
import { describeHassNode } from '../../hass/hassPresentation.js';
import EntitySelector from '../hassbuilder/EntitySelector.vue';

/** An entity node: which Home Assistant entity, and what it feeds. */
const props = defineProps({
    page: { type: Object, required: true },
    graph: { type: Object, required: true },
    node: { type: Object, required: true },
    context: { type: Object, required: true },
    settings: { type: Object, default: () => ({}) },
});
const hass = useHassFlowStore();

// What it feeds (bindings, objects) and the actions that act on it.
const feeds = computed(() => props.graph.wires
    .filter(wire => wire.from.node === props.node.id || wire.to.node === props.node.id)
    .map(wire => {
        if (wire.to.object !== undefined) {
            const object = props.context.getObject(wire.to.object);
            const name = object ? `${object.obj} p${props.page.haspid}b${object.haspid}` : 'missing object';
            return { wire, nodeId: null, label: `Primary Entity of ${name}` };
        }
        const targeted = wire.to.node === props.node.id;
        const other = findNode(props.graph, targeted ? wire.from.node : wire.to.node);
        const view = other ? describeHassNode(other) : null;
        const role = targeted ? 'targeted by ' : '';
        return { wire, nodeId: other?.id ?? null, label: view ? `${role}${view.icon} ${view.title} · ${view.summary}` : 'missing node' };
    }));
</script>
